import React, { useContext, useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import useHasScrolledDown from '../../_helpers/useHasScrolledDown';
import { GlobalContext } from '../../_helpers/GlobalState';
import axios from "axios";
import { ApiUrl } from '../../../const';
import "./header-glass.css";

export function Header() {
    const { WebsiteData } = useContext(GlobalContext);
    const { addWebData } = useContext(GlobalContext);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isTransparent, setIsTransparent] = useState(true);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}${ApiUrl.HomePageUrl}`).then((response) => {
            addWebData(response.data);
        });
    }, []);

    const hasScrolledDown = useHasScrolledDown();

    // Handle transparency based on scroll and page
    useEffect(() => {
        const handleScroll = () => {
            const isHomePage = window.location.pathname === '/';
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            setIsTransparent(isHomePage && scrollTop < 100);
        };

        handleScroll();
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleMobileMenu = () => {
        const newState = !isMobileMenuOpen;
        setIsMobileMenuOpen(newState);
        
        // Prevent body scroll when menu is open
        if (newState) {
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
        } else {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        }
    };

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(false);
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
    };

    // Close mobile menu on window resize to desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 992 && isMobileMenuOpen) {
                closeMobileMenu();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isMobileMenuOpen]);

    // Cleanup body scroll on unmount
    useEffect(() => {
        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
        };
    }, []);

    // Close menu when clicking outside (on overlay)
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            closeMobileMenu();
        }
    };

    return (
        <>
            <header className={`glass-header ${hasScrolledDown ? 'scrolled' : ''} ${false ? 'transparent' : ''}`}>
                <nav className="glass-nav">
                    <div className="glass-nav-container">
                        
                        {/* Left Logo */}
                        <div className="nav-left">
                            <Link  to="/" onClick={closeMobileMenu}>
                                <img 
                                    className="brand-logo" 
                                    src={WebsiteData?.Website?.HomePage?.LogoUrl} 
                                    alt="RKG Technical Services" 
                                />
                            </Link>
                        </div>

                        {/* Center Navigation */}
                        <div className="nav-center">
                            <ul className="nav-links">
                                <li className="nav-item">
                                    <NavLink 
                                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                        to="/"
                                    >
                                        <i className="fas fa-home nav-icon"></i>
                                        <span className="nav-text">Home</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink 
                                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                        to="/about-us"
                                    >
                                        <i className="fas fa-users nav-icon"></i>
                                        <span className="nav-text">About</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink 
                                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                        to="/our-services"
                                    >
                                        <i className="fas fa-cogs nav-icon"></i>
                                        <span className="nav-text">Services</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink 
                                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                        to="/career"
                                    >
                                        <i className="fas fa-briefcase nav-icon"></i>
                                        <span className="nav-text">Career</span>
                                    </NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink 
                                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                                        to="/our-works"
                                    >
                                        <i className="fas fa-images nav-icon"></i>
                                        <span className="nav-text">Gallery</span>
                                    </NavLink>
                                </li>
                            </ul>
                        </div>

                        {/* Right Contact */}
                        <div className="nav-right">
                            <Link 
                                to="/contact-us" 
                                className="nav-link contact-special"
                            >
                                <i className="fas fa-phone nav-icon"></i>
                                <span className="nav-text">Contact</span>
                            </Link>
                        </div>

                        {/* Mobile Menu Toggle */}
                        <button 
                            className={`mobile-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                            onClick={toggleMobileMenu}
                            aria-label="Toggle navigation menu"
                            aria-expanded={isMobileMenuOpen}
                        >
                            <span className="toggle-line"></span>
                            <span className="toggle-line"></span>
                            <span className="toggle-line"></span>
                        </button>
                    </div>
                </nav>
            </header>

            {/* Mobile Menu Overlay */}
            <div 
                className={`mobile-overlay ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={handleOverlayClick}
                aria-hidden={!isMobileMenuOpen}
            ></div>

            {/* Mobile Menu */}
            <div className={`mobile-menu ${isMobileMenuOpen ? 'active' : ''}`}>
                {/* Mobile Menu Header */}
                <div className="mobile-header">
                    <div className="mobile-logo">
                        <img 
                            src={WebsiteData?.Website?.HomePage?.LogoUrl} 
                            alt="RKG Technical Services" 
                        />
                    </div>
                    <button 
                        className="mobile-close"
                        onClick={closeMobileMenu}
                        aria-label="Close navigation menu"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                {/* Mobile Navigation Menu */}
                <ul className="mobile-nav">
                    <li className="mobile-nav-item">
                        <NavLink 
                            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                            to="/"
                            onClick={closeMobileMenu}
                        >
                            <i className="fas fa-home"></i>
                            <span>Home</span>
                        </NavLink>
                    </li>
                    <li className="mobile-nav-item">
                        <NavLink 
                            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                            to="/about-us"
                            onClick={closeMobileMenu}
                        >
                            <i className="fas fa-users"></i>
                            <span>About Us</span>
                        </NavLink>
                    </li>
                    <li className="mobile-nav-item">
                        <NavLink 
                            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                            to="/our-services"
                            onClick={closeMobileMenu}
                        >
                            <i className="fas fa-cogs"></i>
                            <span>Services</span>
                        </NavLink>
                    </li>
                    <li className="mobile-nav-item">
                        <NavLink 
                            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                            to="/career"
                            onClick={closeMobileMenu}
                        >
                            <i className="fas fa-briefcase"></i>
                            <span>Career</span>
                        </NavLink>
                    </li>
                    <li className="mobile-nav-item">
                        <NavLink 
                            className={({ isActive }) => `mobile-nav-link ${isActive ? 'active' : ''}`}
                            to="/our-works"
                            onClick={closeMobileMenu}
                        >
                            <i className="fas fa-images"></i>
                            <span>Gallery</span>
                        </NavLink>
                    </li>
                </ul>

                {/* Mobile Contact Section */}
                <div className="mobile-contact">
                    <Link 
                        to="/contact-us" 
                        className="mobile-contact-btn"
                        onClick={closeMobileMenu}
                    >
                        <i className="fas fa-phone"></i>
                        <span>Contact Us</span>
                    </Link>
                </div>
            </div>
        </>
    );
}
